import * as tslib_1 from "tslib";
import { environment } from '../environment';
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var MapLayerUsageApi = /** @class */ (function () {
    function MapLayerUsageApi(api) {
        this.api = api;
    }
    MapLayerUsageApi.prototype.saveMapUsage = function (mapId, filter, district) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n        mutation AddMapUsage($mapId: Int!, $filter: String!, $district: Int!, $applicationId: Int!) {\n            addMapUsage(mapId: $mapId, filter: $filter, district: $district, applicationId: $applicationId)\n        }", { mapId: mapId, district: district, filter: filter, applicationId: environment.appId }, 'POST', 'addMapUsage')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapLayerUsageApi.prototype.saveLayerUsage = function (layerId, filter, district) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation AddLayerUsage($layerId: Int!, $filter: String!, $district: Int!, $applicationId: Int!) {\n            addLayerUsage(layerId: $layerId, filter: $filter, district: $district, applicationId: $applicationId)\n        }", { layerId: layerId, district: district, filter: filter, applicationId: environment.appId }, 'POST', 'addLayerUsage')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapLayerUsageApi.ngInjectableDef = i0.defineInjectable({ factory: function MapLayerUsageApi_Factory() { return new MapLayerUsageApi(i0.inject(i1.Api)); }, token: MapLayerUsageApi, providedIn: "root" });
    return MapLayerUsageApi;
}());
export { MapLayerUsageApi };
